<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01">
<a id="page06"></a>
<a id="page07"></a>
<div class="chapterHead">
<h2 class="chapterTitle2"><span class="xrefInternal"><a href="#/contents#fm_01"><span class="bold">Foreword</span></a></span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText"><em class="italic">Vacuum Diagrams</em> is a novel based on the short stories which—together with my novels <em class="italic">Raft</em> (1991), <em class="italic">Timelike Infinity</em> (1992), <em class="italic">Flux</em> (1993), and <em class="italic">Ring</em> (1994)—comprise my “Xeelee Sequence” Future History.</p>
<p class="para">The stories, written between 1987 and 1995, have been revised for this edition; a new timeline is appended; references to the novels are included as footnotes, and a new short story (“Eve”) has been included as bridging material.</p>
<p class="para">Of the twenty-two stories included here, four were first published in <em class="italic">Isaac Asimov’s Science Fiction Magazine,</em> one in <em class="italic">SF Age,</em> one in a <em class="italic">Writers Of The Future</em> anthology, and eight in <em class="italic">Interzone</em>. Two (“Lieserl” and “Cilia-of-Gold”) have been included in annual <em class="italic">Legend Year’s Best SF</em> collections, edited by Gardner Dozois. The other stories mostly appeared in small-press magazines and, while fans are aware of the pieces, they have been largely unavailable before this collection.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// for.vue?ce76147e